import { loc } from "../i18n/survey";

enum Nutrition {
  CookAtHome = "CookAtHome",
  EatOut = "EatOut",
  LiveWithFamily = "LiveWithFamily",
  Weekends = "Weekends",
  LateNightSnacking = "LateNightSnacking",
}

const nutritionQuestion = {
  name: "nutrition",
  title: loc("quiz.nutrition.title"),
  description: loc("quiz.shared.chooseAnyThatApply"),
  descriptionLocation: 'underTitle',
  type: "checkbox",
  choices: [
    {
      value: Nutrition.CookAtHome,
      text: loc("quiz.nutrition.choices.cookAtHome"),
    },
    {
      value: Nutrition.LiveWithFamily,
      text: loc("quiz.nutrition.choices.liveWithFamily"),
    },
    {
      value: Nutrition.EatOut,
      text: loc("quiz.nutrition.choices.eatOut"),
    },
    {
      value: Nutrition.Weekends,
      text: loc("quiz.nutrition.choices.weekends"),
    },
    {
      value: Nutrition.LateNightSnacking,
      text: loc("quiz.nutrition.choices.lateNight"),
    },
  ],
  // showOtherItem: true,
  isRequired: true,
};

const nutritionRestrictionsQuestion = {
  name: "nutritionRestrictions",
  title: loc("quiz.nutritionRestrictions.title"),
  description: loc("quiz.shared.chooseAnyThatApply"),
  descriptionLocation: 'underTitle',
  type: 'checkbox',
  choices: [
    { value: 'Vegan', text: loc("quiz.nutritionRestrictions.choices.vegan") },
    { value: 'Vegetarian', text: loc("quiz.nutritionRestrictions.choices.vegetarian") },
    { value: 'Gluten Free', text: loc("quiz.nutritionRestrictions.choices.glutenFree") },
    { value: 'Dairy Free', text: loc("quiz.nutritionRestrictions.choices.dairyFree") },
  ],
  showNoneItem: true,
  // "None" agrees with a feminine noun in Spanish (lesión, restricción, opción).
  noneText: loc("quiz.shared.noneFeminine"),
  // showOtherItem: true,
};

export { Nutrition, nutritionQuestion, nutritionRestrictionsQuestion };
